import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'

export interface RoutabilityPoint {
  latitude: number
  longitude: number
}

export interface RoutabilityResult {
  latitude: number
  longitude: number
  routable: boolean
  reason: string | null
  snap_distance_m: number | null
  snapped_latitude: number | null
  snapped_longitude: number | null
  street: string | null
  reachability: number | null
  min_reachability: number
}

export interface RoutabilityResponse {
  min_reachability: number
  results: RoutabilityResult[]
}

@Injectable({
  providedIn: 'root',
})
export class RoutabilityService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl

  testRoutability(
    points: RoutabilityPoint[],
    minReachability = 20
  ): Observable<RoutabilityResponse> {
    return this.http.post<RoutabilityResponse>(
      `${this.planifyApiUrl}/interventions/test-routability`,
      { points, minReachability }
    )
  }
}
